import PropTypes from 'prop-types';

import { TABLE_SIZES } from './consts';
import { TableSize } from './types';

const tableSizeTheme = PropTypes.shape({
  size: PropTypes.oneOf<TableSize>(Object.values(TABLE_SIZES)).isRequired,
  rowHeight: PropTypes.number.isRequired,
  cellPadding: PropTypes.number.isRequired,
  iconCellWidth: PropTypes.number.isRequired,
});

/* ¯\_(ツ)_/¯ FIXME: typescript chaos here */
const cell = PropTypes.any;
const row = PropTypes.any;
const column = PropTypes.any;
const headerGroup = PropTypes.any;
const table = PropTypes.any;

export default {
  tableSizeTheme,
  cell,
  row,
  column,
  headerGroup,
  table,
};
